import builder from "@builder.io/react";
import { registerBuilderComponents } from "@faire/web/builder/registerBuilderComponents/registerBuilderComponents";
import { registerBuilderDesignTokens } from "@faire/web/builder/registerBuilderDesignTokens/registerBuilderDesignTokens";
import once from "lodash/once";

export const initializeBuilder = once((apiKey: string | undefined) => {
  if (apiKey) {
    builder.init(apiKey);
    registerBuilderComponents();
    registerBuilderDesignTokens();
  }
});
